import { render, staticRenderFns } from "./SlicesSeparator.vue?vue&type=template&id=8e55ef1e&"
import script from "./SlicesSeparator.vue?vue&type=script&lang=js&"
export * from "./SlicesSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports